import IUser from 'models/User';

import { ReduxStore } from 'store/types';

function getAllList(state: ReduxStore): IUser[] {
  return state.user.getAll.list;
}

export default getAllList;
